"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_NAME_EN = exports.BRAND_NAME_FR = void 0;
exports.BRAND_NAME_FR = 'Accès Impôt';
exports.BRAND_NAME_EN = 'Elio Tax';
//# sourceMappingURL=constants.js.map